import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
require('@/assets/css/style.css')
require('@/assets/css/style_mobile.css')
require('@/assets/css/ewc_style.css')
require('@/assets/css/ewc_style_p.css')
require('@/assets/css/size.css')
createApp(App).use(router).mount('#app')
